import React, { useState, useEffect, createContext, useContext } from "react";
import { useAuth } from "../../hooks";
import { getAllAdmins } from "../../modules/Admins/hooks/AdminsHook";
import { getGAAdmins } from "../../GeneralAdmin/modules/GAAdminUsers/hooks/GAAdminHooks";

export const AdminsContext = createContext();
export const useAdminsContext = () => useContext(AdminsContext);

export const AdminsProvider = ({ children }) => {
  const [allAdmins, setAllAdmins] = useState([]);
  const [loading, setLoading] = useState(false);

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("firstName");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(200);

  //General Admin states
  const [GAAdmins, setGAAdmins] = useState([]);
  //General Admin states

  const { currentUser, organizationId } = useAuth();

  // useEffect(() => {
  //   handleGetAllAdmins();
  // }, [currentUser]);

  const handleGetAllAdmins = async () => {
    try {
      console.log("org id:::", currentUser.organization);
      let temp = [];
      const querySnapshot = await getAllAdmins(organizationId ? organizationId : currentUser.organization);
      querySnapshot.docs.forEach(async (item) => {
        temp.push({
          ...item.data(),
          id: item.id,
        });
      });
      setAllAdmins(temp);
    } catch (error) {
      console.error("Error fetching data from Firestore:", error.message);
      setLoading(false);
    }
  };

  //General Admin functions
  const handleGetGAAdmins = async () => {
    try {
      setLoading(true);
      let temp = [];
      const querySnapshot = await getGAAdmins();
      querySnapshot.docs.forEach(async (item) => {
        temp.push({
          ...item.data(),
          id: item.id,
        });
      });
      setGAAdmins(temp);
    } catch (error) {
      console.error("Error fetching data from Firestore:", error.message);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  //General Admin functions

  return (
    <AdminsContext.Provider
      value={{
        handleGetAllAdmins,
        allAdmins,
        setAllAdmins,
        loading,
        setLoading,
        //GA states and functions
        GAAdmins,
        setGAAdmins,
        handleGetGAAdmins,
        //GA states and functions
        order,
        setOrder,
        orderBy,
        setOrderBy,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
      }}
    >
      {children}
    </AdminsContext.Provider>
  );
};
